import { cn } from "@omni/utils/styles";
import { useRef } from "react";

import { Spinner } from "@/components/General/Spinner/spinner.component";

import { usePaintConfiguratorContext } from "../../context/paintConfigurator.context";

const Steps = () => {
    const { steps, currentStep, isRestoringState } =
        usePaintConfiguratorContext();
    const currentIndex = currentStep?.index ?? 0;

    const prevIndexRef = useRef<number | null>(null);
    const isAnimating =
        prevIndexRef.current !== null && prevIndexRef.current !== currentIndex;
    const isGoingForward =
        prevIndexRef.current === null || currentIndex > prevIndexRef.current;
    prevIndexRef.current = currentIndex;

    const step = steps.at(currentIndex);
    if (!step) return null;
    const { component: StepComponent } = step;

    return (
        <div className={cn("tw:grid tw:grid-cols-4 tw:gap-4")}>
            <div className={cn("tw:col-span-4")}>
                <div className={cn("tw:relative tw:p-2")}>
                    <div
                        key={currentIndex}
                        className={cn("tw:duration-500", {
                            "tw:animate-slide-in-right":
                                isAnimating && isGoingForward,
                            "tw:animate-slide-in-left":
                                isAnimating && !isGoingForward
                        })}
                    >
                        {isRestoringState ? (
                            <div
                                className={cn(
                                    "tw:h-full tw:w-full tw:flex tw:items-center tw:justify-center tw:mt-10"
                                )}
                            >
                                <Spinner />
                            </div>
                        ) : (
                            <StepComponent />
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export { Steps };
